
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.37 4.907l1.735-.587a1 1 0 011.267.627l.962 2.842a1 1 0 01-.627 1.268l-1.895.64.004.83a7 7 0 001.418 4.193l.5.661 1.895-.64a1 1 0 011.268.626l.96 2.842a1 1 0 01-.626 1.268l-1.734.586a2 2 0 01-1.978-.407l-.518-.466A13 13 0 017.917 7.116l.13-.685A2 2 0 019.37 4.907z","stroke":"#fff"}})])
      }
    
      }
    